import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DeletePartnerDialog } from '../deletePartnerDialog/DeletePartnerDialog'

import { PercentButton } from '@percent/admin-dashboard/common/components'
import styles from './PartnerDeletePanel.module.scss'
import { Flex } from '@percent/lemonade'

export function PartnerDeletePanel({ partnerId, partnerName }: { partnerId: string; partnerName: string }) {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const handleDeletePartner = () => setOpenDeleteModal(true)
  const handleCloseDeletePartner = () => setOpenDeleteModal(false)
  const { t } = useTranslation()

  return (
    <>
      <Flex justify="space-between" align="center" className={styles.container}>
        <Flex direction="column" justify="center" className={styles.infoText}>
          {t('typography.deletePartner')}
          <br />
          <span>{t('typography.deletingPartner')}</span>
        </Flex>
        <div className={styles.statusSwitchTableCell}>
          <PercentButton
            title={t('button.delete')}
            onClick={handleDeletePartner}
            className={styles.deleteButton}
            outlined
            textColour="secondaryTextColour"
            testId="delete-partner-button"
          />
        </div>
      </Flex>
      {openDeleteModal && (
        <DeletePartnerDialog
          onClose={handleCloseDeletePartner}
          openDeleteModal={openDeleteModal}
          partnerName={partnerName}
          query={{ id: partnerId }}
        />
      )}
    </>
  )
}
